module.exports = __webpack_public_path__ + "static/media/asuthosh.ad33c995.png";